import {ApiManager} from "../api/ApiManager"

export class LifestylePlanActions {
    static fetchFitnessActivities(input: string): Promise<any> {
        return ApiManager.getAlbusApis().getFitnessActivities(input);
    }
    static fetchMindfulnessActivities(input: string): Promise<any> {
        return ApiManager.getMaverickApis().getMindfulnessActivities(input);
    }
}